export function getVehicleServiceEndpoint(encryptedVin: string, language?: string): string {
    return `/vehicle-service/vehicle/${encryptedVin}/${language}`;
}
